import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { MERCH_CARD } from '../../../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../../../hooks/loadingHooks';
import { productsFromProductInventorySelector } from '../../../../selectors/ProductInventorySelectors';
import { trackClickedLink } from '../../../../utils/tracking/trackingEventUtils';
import { BrandingAndLimitFeatures } from '../BrandingAndLimitFeatures';
import { StandardLowerTierMessage } from '../StandardLowerTierMessage';
import { UncategorizedFeatures } from '../UncategorizedFeatures';
import { useCategorizedPriorityFeatures } from '../useFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandardFeaturesContainer = ({
  productLevel,
  productLine,
  apiName,
  isCollapsible = false
}) => {
  const isAppReady = useGlobalLoading();
  const ownedProducts = useSelector(state => {
    if (!isAppReady) return [];
    return productsFromProductInventorySelector(state);
  });
  const isFreePortal = isAppReady && ownedProducts && ownedProducts.length <= 0;
  const {
    loading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  } = useCategorizedPriorityFeatures({
    apiName
  });
  const history = useHistory();
  const handleClick = () => {
    trackClickedLink({
      name: 'business-objective-link',
      value: getI18nText('merchCards.businessObjectives.freeToolsWithLimits', {
        locale: 'en-us'
      }),
      type: 'internal',
      url: '/crm',
      trackingSource: MERCH_CARD
    });
    history.push('/crm');
  };
  if (brandingAndLimitFeatures.length) {
    return /*#__PURE__*/_jsx(BrandingAndLimitFeatures, {
      brandingAndLimitFeatures: brandingAndLimitFeatures,
      uncategorizedFeatures: uncategorizedFeatures,
      loading: loading,
      handleClick: handleClick,
      isCollapsible: isCollapsible,
      isFreePortal: isFreePortal
    });
  }
  if (uncategorizedFeatures.length) {
    return /*#__PURE__*/_jsx(UncategorizedFeatures, {
      uncategorizedFeatures: uncategorizedFeatures,
      loading: loading,
      lowerTierMessage: /*#__PURE__*/_jsx(StandardLowerTierMessage, {
        productLevel: productLevel,
        productLine: productLine,
        handleClick: handleClick,
        isFreePortal: isFreePortal
      }),
      isCollapsible: isCollapsible
    });
  }
  return null;
};